import { PreOrderTimeSlot } from '@rbi-ctg/menu';

const formatISODate = (date: Date) => {
  return date.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: 'numeric',
  });
};

export const getPreOrderLabel = (timeslot: PreOrderTimeSlot) =>
  `${formatISODate(new Date(timeslot.start))} - ${formatISODate(new Date(timeslot.end))}`;

export const getPreOrderTimeslotId = (timeslot: PreOrderTimeSlot) =>
  `${timeslot.start}_${timeslot.end}`;
